import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import {PlannerGroup} from '../../types/plannerGroup.types'

const QueryKey = 'planner-groups'

type UsePlannerGroupsParams = {
  plantId: string
}

export const usePlannerGroups = ({plantId}: UsePlannerGroupsParams) => {
  return useQuery({
    queryKey: [QueryKey, plantId],
    queryFn: async () => {
      const {data} = await ApiClient.axiosInstance.get<PlannerGroup[]>(
        `/plantconfig/${plantId}/planner-groups`
      )
      return data
    }
  })
}
